module.exports = __webpack_public_path__ + "static/media/minus-icon.7405a59f.svg";